import React, { useEffect, useState } from "react";
import {
  Steps,
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Checkbox,
  Flex,
  Spin,
  Modal,
  Result,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { getEmployeeRequest, postEmployeeRequest } from "../slices/employee";
import { useTypedSelector } from "../store";
import { getLevelRequest } from "../slices/level";
import { getDepartmentRequest } from "../slices/department";
import { getBranchRequest } from "../slices/branch";

const { Step } = Steps;
const { Option } = Select;

const AddEmployee: React.FC = () => {
  const dispatch = useDispatch();
  const defaultData = {
    person: {
      number_id: "",
      fullname: "",
      place_of_birth: "",
      date_of_birth: null, // Izinkan null
      gender: "",
      nationality: "",
      religion: "",
      marital_status: "",
    },
    contact: {
      phone: "",
      email: "",
      address_id: {
        street: "",
        city: "",
        postal_code: "",
        country: "",
      },
      address_domicile: {
        street: "",
        city: "",
        postal_code: "",
        country: "",
      },
    },
    job: {
      title: "",
      department: "",
      type: "",
      status: "",
      location: "",
      join_date: null,
      report_to: null, // Izinkan null
    },
    benefit: {
      healthInsurance: false,
      allowance: true,
      bpjsKesehatan: true,
      bpjsTenagaKerja: true,
      bpjsHariTua: true,
    },
    employeeId: {
      id: "",
    },
  };
  const [current, setCurrent] = useState(0);
  const [formData, setFormData] = useState(defaultData);
  const [open, setOpen] = useState(false);
  const [isSuccessed, setIsSuccessed] = useState(false);
  const [isFail, setIsFail] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const { message, isLoading, jobTitles, departments, locations, reports } =
    useTypedSelector((state) => {
      return {
        message: state.Employee.message,
        isLoading: state.Employee.pageIsLoading,
        jobTitles: state.Level.levelList,
        departments: state.Department.departmentList,
        locations: state.Branch.branchList,
        reports: state.Employee.employeePersonList,
      };
    });

  console.log("RPT", reports);

  // const jobTitles = ["Manager", "Supervisor", "Staff"];
  // const departments = [{ name: "OPERATION" }, { name: "IT DEVELOPMENT" }];
  // const locations = [{ name: "OPERATION" }, { name: "IT DEVELOPMENT" }];
  // const reports = [{ name: "OPERATION" }, { name: "IT DEVELOPMENT" }];
  const employmentTypes = ["Full-time", "Part-time", "Contract"];
  const statuses = ["active", "inactive"];

  useEffect(() => {
    dispatch(getLevelRequest() as any);
    dispatch(getDepartmentRequest() as any);
    dispatch(getBranchRequest() as any);
    dispatch(getEmployeeRequest() as any);
  }, []);

  useEffect(() => {
    setFormData(defaultData);
    setCurrent(0);
  }, [message]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    stepKey: string,
    fieldKey: string
  ) => {
    const value = e.target.value;
    setFormData((prevData: any) => ({
      ...prevData,
      [stepKey]: {
        ...prevData[stepKey],
        [fieldKey]: value,
      },
    }));
  };

  const handleNestedInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    stepKey: string,
    nestedFieldKey: string,
    addressType: "address_id" | "address_domicile"
  ) => {
    const value = e.target.value;
    setFormData((prevData: any) => ({
      ...prevData,
      [stepKey]: {
        ...prevData[stepKey],
        [addressType]: {
          ...prevData[stepKey][addressType],
          [nestedFieldKey]: value,
        },
      },
    }));
  };

  const handleSelectChange = (
    value: string | null,
    stepKey: string,
    fieldKey: string
  ) => {
    setFormData((prevData: any) => ({
      ...prevData,
      [stepKey]: {
        ...prevData[stepKey],
        [fieldKey]: value,
      },
    }));
  };

  const handleDateChange = (date: any) => {
    setFormData((prevData) => ({
      ...prevData,
      person: {
        ...prevData.person,
        date_of_birth: date ? date.format("YYYY-MM-DD") : null, // Izinkan null
      },
    }));
  };

  const handleDateChangeJoin = (date: any) => {
    setFormData((prevData) => ({
      ...prevData,
      job: {
        ...prevData.job,
        join_date: date ? date.format("YYYY-MM-DD") : null, // Izinkan null
      },
    }));
  };

  const handleCheckboxChange = (checked: boolean, fieldKey: string) => {
    setFormData((prevData) => ({
      ...prevData,
      benefit: {
        ...prevData.benefit,
        [fieldKey]: checked,
      },
    }));
  };

  const next = () => setCurrent(current + 1);
  const prev = () => setCurrent(current - 1);

  const handleSubmit = async () => {
    console.log(formData);
    setIsDisabled(true);
    dispatch(postEmployeeRequest(formData) as any)
      .then((res: any) => {
        console.log(res);
        if (res.payload.status !== 1000) {
          setIsFail(true);
        } else if (res.payload.status === 1000) {
          setIsSuccessed(true);
        } else {
          setOpen(false);
        }
        // setOpen(false)
      })
      .catch((err: any) => {
        console.log(err);
        setOpen(false);
      });
  };

  const showModal = () => {
    setOpen(true);
  };

  const hideModal = () => {
    setIsFail(false);
    setIsSuccessed(false);
    setIsDisabled(false);
    setOpen(false);
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", marginTop: 30 }}>
      <Steps current={current} style={{ marginBottom: 20 }}>
        <Step title="Personal Data" />
        <Step title="Contact" />
        <Step title="Job" />
        <Step title="Benefit" />
      </Steps>

      <Form
        layout="vertical"
        style={{ padding: "20px", background: "#f7f7f7", borderRadius: 8 }}
      >
        {current === 0 && (
          <>
            <Form.Item
              label="ID Number"
              rules={[{ required: true, message: "Please input ID number!" }]}
            >
              <Input
                value={formData.person.number_id}
                onChange={(e) => handleInputChange(e, "person", "number_id")}
              />
            </Form.Item>
            <Form.Item
              label="Full Name"
              rules={[{ required: true, message: "Please input full name!" }]}
            >
              <Input
                value={formData.person.fullname}
                onChange={(e) => handleInputChange(e, "person", "fullname")}
              />
            </Form.Item>
            <Form.Item
              label="Place of Birth"
              rules={[
                { required: true, message: "Please input place of birth!" },
              ]}
            >
              <Input
                value={formData.person.place_of_birth}
                onChange={(e) =>
                  handleInputChange(e, "person", "place_of_birth")
                }
              />
            </Form.Item>
            <Form.Item
              label="Date of Birth"
              rules={[
                { required: true, message: "Please select date of birth!" },
              ]}
            >
              <DatePicker
                value={
                  formData.person.date_of_birth
                    ? dayjs(formData.person.date_of_birth)
                    : null
                }
                style={{ width: "100%" }}
                onChange={handleDateChange}
              />
            </Form.Item>
            <Form.Item
              label="Gender"
              rules={[{ required: true, message: "Please select gender!" }]}
            >
              <Select
                onChange={(value) =>
                  handleSelectChange(value, "person", "gender")
                }
              >
                <Option value="male">Male</Option>
                <Option value="female">Female</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Nationality"
              rules={[{ required: true, message: "Please input nationality!" }]}
            >
              <Input
                value={formData.person.nationality}
                onChange={(e) => handleInputChange(e, "person", "nationality")}
              />
            </Form.Item>
            <Form.Item
              label="Religion"
              rules={[{ required: true, message: "Please select religion!" }]}
            >
              <Select
                onChange={(value) =>
                  handleSelectChange(value, "person", "religion")
                }
              >
                <Option value="ISLAM">Islam</Option>
                <Option value="KRISTEN">Kristen</Option>
                <Option value="KATOLIK">Katolik</Option>
                <Option value="BUDDHA">Buddha</Option>
                <Option value="HINDU">Hindu</Option>
              </Select>
            </Form.Item>
            {/* <Form.Item
              label="Religion"
              rules={[{ required: true, message: "Please input religion!" }]}
            >
              <Input
                value={formData.person.religion}
                onChange={(e) => handleInputChange(e, "person", "religion")}
              />
            </Form.Item> */}
            <Form.Item
              label="Martial Status"
              rules={[
                { required: true, message: "Please select Martial Status!" },
              ]}
            >
              <Select
                onChange={(value) =>
                  handleSelectChange(value, "person", "marital_status")
                }
              >
                <Option value="MENIKAH">Menikah</Option>
                <Option value="BELUM MENIKAH">Belum Menikah</Option>
              </Select>
            </Form.Item>
            {/* <Form.Item
              label="Martial Status"
              rules={[
                { required: true, message: "Please input martial status!" },
              ]}
            >
              <Input
                value={formData.person.marital_status}
                onChange={(e) =>
                  handleInputChange(e, "person", "marital_status")
                }
              />
            </Form.Item> */}
          </>
        )}

        {current === 1 && (
          <>
            <Form.Item
              label="Phone"
              rules={[{ required: true, message: "Please input phone!" }]}
            >
              <Input
                value={formData.contact.phone}
                onChange={(e) => handleInputChange(e, "contact", "phone")}
              />
            </Form.Item>
            <Form.Item
              label="Email"
              rules={[{ required: true, message: "Please input email!" }]}
            >
              <Input
                value={formData.contact.email}
                onChange={(e) => handleInputChange(e, "contact", "email")}
              />
            </Form.Item>
            <Form.Item label="Address ID">
              <Input.Group compact>
                <Form.Item noStyle>
                  <Input
                    placeholder="Street"
                    value={formData.contact.address_id.street}
                    onChange={(e) =>
                      handleNestedInputChange(
                        e,
                        "contact",
                        "street",
                        "address_id"
                      )
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item noStyle>
                  <Input
                    placeholder="City"
                    value={formData.contact.address_id.city}
                    onChange={(e) =>
                      handleNestedInputChange(
                        e,
                        "contact",
                        "city",
                        "address_id"
                      )
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item noStyle>
                  <Input
                    placeholder="Postal Code"
                    value={formData.contact.address_id.postal_code}
                    onChange={(e) =>
                      handleNestedInputChange(
                        e,
                        "contact",
                        "postal_code",
                        "address_id"
                      )
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item noStyle>
                  <Input
                    placeholder="Country"
                    value={formData.contact.address_id.country}
                    onChange={(e) =>
                      handleNestedInputChange(
                        e,
                        "contact",
                        "country",
                        "address_id"
                      )
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item label="Address Domicile">
              <Input.Group compact>
                <Form.Item noStyle>
                  <Input
                    placeholder="Street"
                    value={formData.contact.address_domicile.street}
                    onChange={(e) =>
                      handleNestedInputChange(
                        e,
                        "contact",
                        "street",
                        "address_domicile"
                      )
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item noStyle>
                  <Input
                    placeholder="City"
                    value={formData.contact.address_domicile.city}
                    onChange={(e) =>
                      handleNestedInputChange(
                        e,
                        "contact",
                        "city",
                        "address_domicile"
                      )
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item noStyle>
                  <Input
                    placeholder="Postal Code"
                    value={formData.contact.address_domicile.postal_code}
                    onChange={(e) =>
                      handleNestedInputChange(
                        e,
                        "contact",
                        "postal_code",
                        "address_domicile"
                      )
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item noStyle>
                  <Input
                    placeholder="Country"
                    value={formData.contact.address_domicile.country}
                    onChange={(e) =>
                      handleNestedInputChange(
                        e,
                        "contact",
                        "country",
                        "address_domicile"
                      )
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Input.Group>
            </Form.Item>
          </>
        )}

        {current === 2 && (
          <>
            <Form.Item
              label="Employee ID"
              rules={[{ required: true, message: "Please input Employee ID!" }]}
            >
              <Input
                value={formData.employeeId.id}
                onChange={(e) => handleInputChange(e, "employeeId", "id")}
              />
            </Form.Item>
            <Form.Item
              label="Job Title"
              rules={[{ required: true, message: "Please select job title!" }]}
            >
              <Select
                value={formData.job.title}
                onChange={(value) => handleSelectChange(value, "job", "title")}
              >
                {jobTitles.map((title) => (
                  <Option key={title._id} value={title.name}>
                    {title.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Department"
              rules={[{ required: true, message: "Please select department!" }]}
            >
              <Select
                value={formData.job.department}
                onChange={(value) =>
                  handleSelectChange(value, "job", "department")
                }
                showSearch
                placeholder="Search department by name"
                filterOption={(input: any, option: any) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
                options={departments.map((dept) => ({
                  label: dept.name, // Text yang ditampilkan
                  value: dept.name, // Nilai yang dipilih
                }))}
              ></Select>
            </Form.Item>
            <Form.Item
              label="Join Date"
              rules={[{ required: true, message: "Please select Join date!" }]}
            >
              <DatePicker
                value={
                  formData.job.join_date ? dayjs(formData.job.join_date) : null
                }
                style={{ width: "100%" }}
                onChange={handleDateChangeJoin}
              />
            </Form.Item>
            <Form.Item
              label="Location"
              rules={[{ required: true, message: "Please select location!" }]}
            >
              <Select
                value={formData.job.location}
                onChange={(value) =>
                  handleSelectChange(value, "job", "location")
                }
                showSearch
                placeholder="Search location by name"
                filterOption={(input: any, option: any) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
                options={locations.map((loc) => ({
                  label: loc.name, // Text yang ditampilkan
                  value: loc._id, // Nilai yang dipilih
                }))}
              ></Select>
            </Form.Item>
            <Form.Item
              label="Employment Type"
              rules={[
                { required: true, message: "Please select employment type!" },
              ]}
            >
              <Select
                value={formData.job.type}
                onChange={(value) => handleSelectChange(value, "job", "type")}
              >
                {employmentTypes.map((type) => (
                  <Option key={type} value={type}>
                    {type}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Status"
              rules={[{ required: true, message: "Please select status!" }]}
            >
              <Select
                value={formData.job.status}
                onChange={(value) => handleSelectChange(value, "job", "status")}
              >
                {statuses.map((status) => (
                  <Option key={status} value={status}>
                    {status}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Reports To"
              rules={[
                { required: true, message: "Please select a supervisor!" },
              ]}
            >
              <Select
                value={formData.job.report_to}
                onChange={(value) =>
                  handleSelectChange(value, "job", "report_to")
                }
                showSearch
                placeholder="Search Approval by name"
                filterOption={(input: any, option: any) =>
                  option?.label.toLowerCase().includes(input.toLowerCase())
                }
                options={reports.map((report) => ({
                  label: report.name, // Text yang ditampilkan
                  value: report.code, // Nilai yang dipilih
                }))}
              ></Select>
            </Form.Item>
          </>
        )}

        {current === 3 && (
          <>
            <>
              <Form.Item label="Health Insurance">
                <Checkbox
                  checked={formData.benefit.healthInsurance}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.checked, "healthInsurance")
                  }
                />
              </Form.Item>
              <Form.Item label="Allowance">
                <Checkbox
                  checked={formData.benefit.allowance}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.checked, "allowance")
                  }
                />
              </Form.Item>
              <Form.Item label="BPJS Kesehatan">
                <Checkbox
                  checked={formData.benefit.bpjsKesehatan}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.checked, "bpjsKesehatan")
                  }
                />
              </Form.Item>
              <Form.Item label="BPJS Tenaga Kerja">
                <Checkbox
                  checked={formData.benefit.bpjsTenagaKerja}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.checked, "bpjsTenagaKerja")
                  }
                />
              </Form.Item>
              <Form.Item label="BPJS Hari Tua">
                <Checkbox
                  checked={formData.benefit.bpjsHariTua}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.checked, "bpjsHariTua")
                  }
                />
              </Form.Item>
            </>
          </>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 20,
          }}
        >
          {current > 0 && (
            <Button onClick={() => prev()} style={{ marginRight: 8 }}>
              Previous
            </Button>
          )}
          {current < 3 && (
            <Button type="primary" onClick={() => next()}>
              Next
            </Button>
          )}
          {current === 3 && (
            <Button
              type="primary"
              disabled={isDisabled}
              onClick={() => showModal()}
            >
              Submit
            </Button>
          )}
        </div>
      </Form>

      <Modal
        title="Confirm"
        open={open}
        onOk={() => handleSubmit()}
        onCancel={hideModal}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{ disabled: isDisabled }}
      >
        <p>Create New Employee</p>
        <p>Are you sure to be continue?</p>
        {isLoading && (
          <>
            <Flex align="center" gap="middle">
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />}
              />
            </Flex>
          </>
        )}
        {isSuccessed && (
          <>
            <Result status="success" title="Successfully Create Employee" />
          </>
        )}
        {isFail && (
          <>
            <Result status="warning" title="Create Employee Is Fail" />
          </>
        )}
      </Modal>
    </div>
  );
};

export default AddEmployee;
